// extracted by mini-css-extract-plugin
module.exports = {"user-form":"ChangePassword_user-form__3u5bj","button":"ChangePassword_button__ZzAuI"};